import { IncomingHttpHeaders } from "http";

import { ApolloClient, ApolloLink, NormalizedCacheObject } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import apolloLogger from "apollo-link-logger";
import { createUploadLink } from "apollo-upload-client";

import { createCache } from "./cache";
import { createErrorLink } from "./createErrorLink";
import { createMaintenanceCheckLink } from "./createMaintenanceCheckLink";

const GRAPHQL_ENDPOINT = `${process.env.NEXT_PUBLIC_CURON_API_ENDPOINT}/momo/patients/graphql`;

let apolloClient: ReturnType<typeof createApolloClient> | null;

const authLink = setContext(async (_, { headers }) => {
  return {
    headers: {
      ...headers,
      // TODO: 必要あればトークンを埋める等
    },
  };
});

export const createApolloClient = (headers?: IncomingHttpHeaders) => {
  const cache = createCache();

  return new ApolloClient({
    ssrMode: typeof window === "undefined",
    cache,
    link: ApolloLink.from([
      ...(process.env.NEXT_PUBLIC_APP_ENV === "production" ? [] : [apolloLogger]),
      createMaintenanceCheckLink(),
      createErrorLink(),
      authLink,
      createUploadLink({
        uri: GRAPHQL_ENDPOINT,
        credentials: "include",
        fetchOptions: { credentials: "include" },
        headers: headers as Record<string, string>,
      }),
    ]),
  });
};

/**
 * SSR 時に Apollo Client で取得した state をフロントで復元する処理
 * 当面 SSR で Apollo Client を使用することはないので initialState が存在するケースは無いものと捉えて良い
 */
export const initializeApollo = ({
  initialState,
  headers,
}: {
  initialState?: NormalizedCacheObject;
  headers?: IncomingHttpHeaders;
}) => {
  if (typeof window === "undefined") {
    const createdApolloClient = createApolloClient(headers);

    if (initialState) {
      const existingCache = createdApolloClient.extract();

      // createdApolloClient.cache.restore(merge(existingCache, initialState));
      createdApolloClient.cache.restore(Object.assign(existingCache, initialState));
    }

    return createdApolloClient;
  }

  if (!apolloClient) {
    apolloClient = createApolloClient(headers);
  }

  if (initialState) {
    const existingCache = apolloClient.extract();

    // NOTE: Object.assign より lodash merge 相当の処理を用意して使った方が全てのクエリが復元できるためベター
    // だがそもそも復元するユースケースが無いので必要に応じて整備する
    // apolloClient.cache.restore(merge(existingCache, initialState));
    apolloClient.cache.restore(Object.assign(existingCache, initialState));
  }

  return apolloClient;
};
